var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorloadBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Layer_",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laptop_computer_macbook"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.5,17.5V1.5c0-.6-.4-1-1-1H3.5c-.6,0-1,.4-1,1v16",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.5,19.5H.5c0,1.1.9,2,2,2h25c1.1,0,2-.9,2-2h-11",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.38,14.17h-.8v-7.41c0-.12-.09-.21-.21-.21h-2.02c-.12,0-.21.09-.21.21v7.41h-.91v-5.85c0-.12-.09-.21-.21-.21h-2.02c-.12,0-.21.09-.21.21v5.85h-.91v-4.09c0-.12-.09-.21-.21-.21h-2.02c-.12,0-.21.09-.21.21v4.09h-.8c-.12,0-.21.09-.21.21s.09.21.21.21h10.76c.12,0,.21-.09.21-.21s-.09-.21-.21-.21Zm-9.54,0v-3.88h1.61v3.88h-1.61Zm3.36,0v-5.64h1.61v5.64h-1.61Zm3.36,0v-7.2h1.61v7.2h-1.61Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.69,7.82s.08-.01.12-.04l5.23-3.53-.08.43c-.02.11.05.22.17.25.01,0,.03,0,.04,0,.1,0,.19-.07.21-.17l.18-.92c.02-.11-.05-.22-.17-.25l-.92-.18c-.11-.02-.22.05-.25.17-.02.11.05.22.17.25l.43.08-5.23,3.53c-.1.06-.12.19-.06.29.04.06.11.09.17.09Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorloadBad);
export default __webpack_public_path__ + "static/media/worload_bad.f67a9df0917b414c7e4e584aae462737.svg";
export { ForwardRef as ReactComponent };